// Values wrapped in {{ }} are placeholders that render highlighted on the site.
// Replace them with confirmed information before publishing.
export const company = {
  legalName: 'Tracker Group LLC',
  shortName: 'Tracker Group',
  email: 'soporteoficial.tracker@gmail.com',
  address: '30 N Gould St, Ste N, Sheridan, WY 82801, USA',
  stateOfRegistration: 'Wyoming, USA',
  responseTime: 'Within 24–48 hours',
  salesPlatform: 'Secure online card payment',
  deliveryMethod: 'Instantly by email',
  deliveryTime: 'Immediately after payment is approved',
  lastUpdated: 'September 28, 2026',
};
